export const DELAY_TO_SHOW_TYPING_INDICATOR = 3050

export const DELAY_TO_SCROLL_ON_LOAD = 250 // in ms
